"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Anchor = _interopRequireDefault(require("../Anchor"));
var _Portal = _interopRequireDefault(require("../Portal"));
var _useDidValueChanged = _interopRequireDefault(require("../../hooks/useDidValueChanged"));
var _useOutsideClick = _interopRequireDefault(require("../../hooks/useOutsideClick"));
var _useScrollPosition = _interopRequireDefault(require("../../hooks/useScrollPosition"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Popover = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    show = props.show,
    anchor = props.anchor,
    portalWhenMounted = props.portalWhenMounted,
    onClickOutside = props.onClickOutside,
    onScrollOutside = props.onScrollOutside,
    filterdProps = __rest(props, ["children", "show", "anchor", "portalWhenMounted", "onClickOutside", "onScrollOutside"]);
  var contentRef = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(ref, function () {
    return contentRef.current;
  });
  var position = (0, _useScrollPosition.default)();
  var positionValue = show ? position : undefined;
  var positionCompare = (0, _react.useCallback)(function (prev, curr) {
    return [prev, curr].includes(undefined);
  }, []);
  var didScrollPositionChanged = (0, _useDidValueChanged.default)(positionValue, positionCompare);
  (0, _react.useEffect)(function () {
    if (show && onScrollOutside && typeof onScrollOutside === 'function') {
      if (didScrollPositionChanged) {
        onScrollOutside();
      }
    }
  }, [show, onScrollOutside, didScrollPositionChanged]);
  var handleOnClickOutside = (0, _react.useCallback)(function (event) {
    if (typeof onClickOutside === 'function' && !(anchor === null || anchor === void 0 ? void 0 : anchor.contains(event.target))) {
      onClickOutside(event);
    }
  }, [anchor, onClickOutside]);
  (0, _useOutsideClick.default)(contentRef, handleOnClickOutside);
  return show ? (0, _jsxRuntime.jsx)(_Portal.default, __assign({
    portalWhenMounted: portalWhenMounted
  }, {
    children: (0, _jsxRuntime.jsx)(_Anchor.default, __assign({
      ref: contentRef,
      anchor: anchor
    }, filterdProps, {
      children: children
    }))
  })) : null;
});
Popover.displayName = 'Popover';
var _default = Popover;
exports.default = _default;